import Apply from "../Common/Apply"

const ExportApply = props => {
    return <Apply service_id="4"/>
}

export default ExportApply